import { AuthenticationService } from '../api/authentication.service'
import { DataService } from '@/api'
import RestService from '@/api/rest-service/index'
import lodashGet from 'lodash/get'
import { Notify, LocalStorage } from 'quasar'
import router from '@router'
import store from './index'
import * as apiTo from '@/modular-api'
import { getSubdomainName } from '@/utils/get-subdomain'

const AUTH_SERVICE = new AuthenticationService()
const CONTACTS_SERVICE = new RestService('contacts')

function getTranslation() {
  // return lang.get(args)
  return ''
}

export default {
  handleGlobalLoader(context, value) {
    context.commit('updateGlobalLoader', value)
  },

  login({ commit, state, dispatch }, payload) {
    const subdomainName = getSubdomainName()

    return apiTo.LOGIN(payload).then(async ({ data }) => {
      LocalStorage.set(`${subdomainName}_user`, data.result)
      let redirect = lodashGet(state, 'route.query.redirect')
      let noLoginPath = state.route.name !== 'login'
      let path = state.accessToken ? redirect || (noLoginPath ? state.route.fullPath : '/dashboard') : '/dashboard'
      await router.replace(path)
      commit('updateUser', data.result, { root: true })
    })
  },

  requestPasswordReset(context, payload) {
    return AUTH_SERVICE.requestResetPassword(payload)
  },
  resetPassword(context, payload) {
    return AUTH_SERVICE.resetPassword(payload)
  },
  logout(context) {
    return apiTo.LOGOUT().then(() => {
      context.state.requestCancellationToken.cancel()
      context.dispatch('resetState')
      router.replace({ name: 'login' })
    })
  },
  resetState(context) {
    LocalStorage.remove(`${store.getters.tenant}_authorization`)
    LocalStorage.remove(`${store.getters.tenant}_user`)

    context.commit('updateRequestCancellationToken', null)
    context.commit('updateAccessToken', null)
    context.commit('updateUser', null)
  },
  createNotificationToast(context, opts) {
    if (!opts) return
    let icon = ''
    if (opts.color && opts.color === 'positive') icon = 'fas fa-check'
    if (opts.color && opts.color === 'warning') icon = 'fas fa-exclamation-triangle'
    if (opts.color && opts.color === 'info') icon = 'fas fa-info-circle'
    if (opts.color && opts.color === 'negative') icon = 'fas fa-exclamation-circle'
    if (opts.message) {
      opts.message.map(message => {
        return Notify.create({
          message: message,
          detail: opts.detail,
          icon: opts.icon ? opts.icon : icon,
          enter: 'bounceInRight',
          leave: 'bounceOutRight',
          inline: false,
          color: opts.color ? opts.color : 'danger',
          position: opts.position ? opts.position : 'bottom-right',
          timeout: opts.timeout || 3000,
          actions: [
            {
              label: `${getTranslation('shared.dismiss') || 'Hide'}`,
              color: 'white'
            }
          ]
        })
      })
    }
  },
  handleValidationMessages(context, messages) {
    Object.keys(messages).map(field => {
      store.dispatch(
        'createNotificationToast',
        {
          message: messages[field],
          color: 'warning',
          timeout: 8000
        },
        { root: true }
      )
    })
  },
  downloadFile(context, url) {
    return new DataService().download(url).then(response => {
      let blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = url
      link.click()
    })
  },
  downloadMedia(context, id) {
    return new DataService().downloadMedia(id).then(response => {
      let blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = response.headers['x-suggested-filename']
      link.click()
    })
  },
  updateMemberSettings(context, data) {
    let SERVICE = new DataService('member-settings')
    return SERVICE.makeRequest('put', SERVICE.namespace, data).then(response => {
      context.commit('updateMemberSettings', response.data.result)
    })
  },
  getDefaultSettings(context) {
    let SERVICE = new DataService('settings')
    return SERVICE.get().then(response => {
      context.commit('updateSettings', response.data.result)
      context.commit('setSettingsFetched', true)
      return response.data.result
    })
  },
  getMemberSettings({ commit }) {
    let SERVICE = new DataService('member-settings')
    return SERVICE.get().then(response => {
      commit('updateSettings', response.data.result, { root: true })
      return response.data.result
    })
  },
  updateGlobalDialogVisibility(context, data) {
    context.commit('updateGlobalDialogVisibility', data)
  },
  getEmailPreferences({ commit }) {
    return CONTACTS_SERVICE.getCreateFormData().then(({ data }) =>
      commit('setEmailPreferences', data.result.email_preferences)
    )
  }
}
